/* eslint-disable no-param-reassign */
/* eslint-disable eqeqeq */
/* eslint-disable operator-assignment */
/* eslint-disable prettier/prettier */
/* eslint-disable no-plusplus */
/* eslint-disable radix */
export function isValidCPF(number) {
  let sum;
  let rest;
  sum = 0;
  if (number == '00000000000') return false;

  for (let i = 1; i <= 9; i++) {
    sum = sum + parseInt(number.substring(i - 1, i)) * (11 - i);
  }
  rest = (sum * 10) % 11;

  if (rest == 10 || rest == 11) rest = 0;
  if (rest != parseInt(number.substring(9, 10))) return false;

  sum = 0;
  for (let i = 1; i <= 10; i++) {
    sum = sum + parseInt(number.substring(i - 1, i)) * (12 - i);
  }
  rest = (sum * 10) % 11;

  if (rest == 10 || rest == 11) rest = 0;
  if (rest != parseInt(number.substring(10, 11))) return false;
  return true;
}

export function isValidCNPJ(cnpj) {
  if (!cnpj) return false;
  cnpj = cnpj.replace(/[^\d]+/g, '');

  if (cnpj == '') return false;

  if (cnpj.length != 14) return false;

  if (
    cnpj == '00000000000000' ||
    cnpj == '11111111111111' ||
    cnpj == '22222222222222' ||
    cnpj == '33333333333333' ||
    cnpj == '44444444444444' ||
    cnpj == '55555555555555' ||
    cnpj == '66666666666666' ||
    cnpj == '77777777777777' ||
    cnpj == '88888888888888' ||
    cnpj == '99999999999999'
  ) {
    return false;
  }

  let size = cnpj.length - 2;
  let numeros = cnpj.substring(0, size);
  const digitos = cnpj.substring(size);
  let soma = 0;
  let pos = size - 7;
  for (let i = size; i >= 1; i--) {
    soma += numeros.charAt(size - i) * pos--;
    if (pos < 2) pos = 9;
  }
  let result = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (result != digitos.charAt(0)) return false;

  size = size + 1;
  numeros = cnpj.substring(0, size);
  soma = 0;
  pos = size - 7;
  for (let i = size; i >= 1; i--) {
    soma += numeros.charAt(size - i) * pos--;
    if (pos < 2) pos = 9;
  }
  result = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (result != digitos.charAt(1)) return false;

  return true;
}

export function isValidZipcode(zipcode) {
  if (!zipcode) return false;

  const objER = /^[0-9]{2}\.[0-9]{3}-[0-9]{3}$/;

  zipcode = zipcode.replace(/^\s+|\s+$/g, '');

  if (zipcode.length > 0) {
    if (objER.test(zipcode)) return true;
    return false;
  }
  return false;
}
